import Tagify from "@yaireo/tagify";
import { validateMobilePhoneNumber } from "../framework/utils";
import { createIconOnlyButton, setIcon } from "../framework/components/icon";
import { fullname } from "../utils/format";
import { switchTo } from "../layout/page-tabs";

const contactTagInput = (element) => {
  return new Tagify(element, {
    enforceWhitelist: true,
    whitelist: JSON.parse(element.dataset.rawWhitelist),
    dropdown: {
      maxItems: Infinity,
      enabled: 0,
      closeOnSelect: false,
      classname: "tags-look",
    },
    tagTextProp: "label",
    itemTextProp: "label", // Added setting to work with the custom dropdownItem
    templates: {
      dropdownItem: function (item) {
        return `<div ${this.getAttributes(item)}
                    class='${this.settings.classNames.dropdownItem} ${item.class ? item.class : ""}'
                    tabindex="0"
                    role="option">${item[this.settings.itemTextProp] || item.value}</div>`;
      },
    },
  });
};

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".contact-phone").forEach((phoneInput) => {
    validateMobilePhoneNumber(phoneInput);

    phoneInput.addEventListener("input", (e) => {
      validateMobilePhoneNumber(e.target);
    });
  });

  document.querySelectorAll(".js-contact-accordion").forEach((accordion) => {
    dynamicTitle(accordion);
    deleteButton(accordion);
    autoClose(accordion);
  });

  document.querySelectorAll(".js-company-tags").forEach((companyTags) => contactTagInput(companyTags));

  const saveButtons = document.querySelectorAll(".js-save-form-with-contacts-button");
  saveButtons.forEach((button) => button.addEventListener("click", onClickSaveButton));

  const pageWithContactsElementList = document.getElementsByClassName("js-page-with-contacts");
  const registrationsPageElementList = document.getElementsByClassName("js-registrations-page");

  if (pageWithContactsElementList.length != 1 && registrationsPageElementList.length != 1) {
    return;
  }

  const addContactButtonElementList =
    pageWithContactsElementList.length !== 0
      ? pageWithContactsElementList[0].getElementsByClassName("js-add-contact-btn")
      : registrationsPageElementList[0].getElementsByClassName("js-add-contact-btn");
  if (addContactButtonElementList.length == 0) {
    return;
  }

  const addContactButton = addContactButtonElementList[0];

  addContactButton.addEventListener("click", function (e) {
    e.preventDefault();
    const insertionPoint = document.querySelector(".js-add-contact-div");

    const el = document.getElementById("add_contact");
    const time = new Date().getTime();
    const template = el.getAttribute("data-template");
    let uniq_template = template.replace(/\[0\]/g, `[${time}]`);
    uniq_template = uniq_template.replace(/_0_/g, `_${time}_`);
    insertionPoint.insertAdjacentHTML("beforebegin", uniq_template);

    const insertedNode = insertionPoint.previousElementSibling;

    const tags = insertedNode.querySelector(".js-company-tags");
    const phoneInput = insertedNode.getElementsByClassName("contact-phone")[0];

    if (phoneInput) {
      validateMobilePhoneNumber(phoneInput);
      phoneInput.addEventListener("input", (e) => {
        validateMobilePhoneNumber(e.target);
      });
    }

    if (tags) {
      contactTagInput(tags);
    }
    dynamicTitle(insertedNode);
    deleteButton(insertedNode, true);
    autoClose(insertedNode);
    closeAll();
    insertedNode.setAttribute("open", true);
  });
});

const dynamicTitle = (accordionElement) => {
  const firstnameInput = accordionElement.querySelector(".js-contact-firstname");
  const lastnameInput = accordionElement.querySelector(".js-contact-lastname");
  const accordionTitle = accordionElement.querySelector(".label");
  if (lastnameInput.value) {
    accordionTitle.textContent = fullname(firstnameInput.value, lastnameInput.value);
  }
  if (firstnameInput && lastnameInput) {
    firstnameInput.addEventListener("change", () => {
      accordionTitle.innerText = fullname(firstnameInput.value, lastnameInput.value);
    });

    lastnameInput.addEventListener("change", () => {
      accordionTitle.innerText = fullname(firstnameInput.value, lastnameInput.value);
    });
  }
};

const deleteButton = (accordionElement, isNew) => {
  const accordionFirstChild = accordionElement.firstElementChild;
  const deleteInput = accordionElement.getElementsByClassName("js-contact-delete")[0];
  if (deleteInput || isNew) {
    const accordionIcon = accordionElement.getElementsByClassName("accordion__icon")[0];
    const deleteButton = createIconOnlyButton("trashcan");
    accordionFirstChild.insertBefore(deleteButton, accordionIcon);
    deleteButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (accordionElement.getAttribute("data-deleted")) {
        accordionElement.removeAttribute("data-deleted");
        setIcon(deleteButton, "trashcan");
        accordionFirstChild.setAttribute("style", "text-decoration: none");
        for (const child of accordionElement.querySelectorAll("input:not([type='hidden']), select, textarea")) {
          child.removeAttribute("disabled");
        }
        if (deleteInput) {
          deleteInput.value = false;
        }
      } else {
        accordionElement.setAttribute("data-deleted", true);
        accordionFirstChild.setAttribute("style", "text-decoration: line-through");
        for (const child of accordionElement.querySelectorAll("input:not([type='hidden']), select, textarea")) {
          child.setAttribute("disabled", true);
        }
        setIcon(deleteButton, "undo");
        if (deleteInput) {
          deleteInput.value = true;
        } else {
          accordionElement.remove();
        }
      }
    });
  }
};

const autoClose = (accordionElement) => {
  const accordionHeader = accordionElement.firstElementChild;
  accordionHeader.addEventListener("click", (e) => {
    e.preventDefault();
    if (accordionElement.getAttribute("open")) {
      accordionElement.removeAttribute("open");
    } else {
      closeAll();
      accordionElement.setAttribute("open", true);
    }
  });
};

const closeAll = () => {
  document.querySelectorAll(".js-contact-accordion").forEach((accordion) => {
    accordion.removeAttribute("open");
  });
};

const onClickSaveButton = (event) => {
  const form = document.querySelector(".js-form-with-contact");
  // Check if we need to switch user to the errored tab if any error
  if (form.checkValidity()) {
    return;
  }

  // The submit button has no explicit type, so it submits the form: the browser would synchronously try to focus the
  // first invalid field, which is still hidden behind its tab/accordion, and throw "is not focusable". Block that and
  // drive the reveal + reportValidity ourselves.
  event.preventDefault();

  // Use :invalid so we catch every native constraint (empty required, bad email format, pattern, ...), not just empty
  // fields. willValidate filters out containers (fieldset, ...) that match :invalid on behalf of their children.
  const invalidControls = Array.from(form.querySelectorAll(":invalid")).filter((control) => control.willValidate);

  const invalidAccordions = new Set(invalidControls.map((control) => control.closest(".js-contact-accordion")));
  invalidAccordions.delete(null);
  invalidAccordions.forEach((accordion) => accordion.setAttribute("open", true));

  // reportValidity() reports the first invalid control in form order, so reveal the tab holding that control:
  // switching anywhere else would leave it hidden and the browser would show no validation message at all.
  const firstInvalidControl = invalidControls[0];
  const firstInvalidInContacts = Boolean(firstInvalidControl && firstInvalidControl.closest(".js-contact-accordion"));
  switchTo(firstInvalidInContacts ? "contacts" : "info");

  // The tab reveal is applied by Alpine's reactive x-show on the next animation frame. Wait for that paint before
  // reporting, otherwise the field is still display:none and reportValidity() throws "is not focusable".
  requestAnimationFrame(() => requestAnimationFrame(() => form.reportValidity()));
};
